import { AI_CHATBOT_ACTIONS, type AllChatbotActions } from "../actions/actions";
import type { ChatbotState } from "../types/chatbot.reducer.type";

export function flagsReducer(state: ChatbotState, action: AllChatbotActions) {
  switch (action.type) {
    case AI_CHATBOT_ACTIONS.SET_IS_SENDING_ACTION:
      return {
        ...state,
        isSending: action.payload.isSending,
      };
    case AI_CHATBOT_ACTIONS.SET_SHOW_EMPTY_STATE_ACTION:
      return {
        ...state,
        showEmptyState: action.payload.showEmptyState,
      };
    case AI_CHATBOT_ACTIONS.SET_SCROLL_TO_BOTTOM_ACTION:
      return {
        ...state,
        scrollToBottom: action.payload.scrollToBottom,
      };
    case AI_CHATBOT_ACTIONS.SET_SHOW_SCROLL_TO_BOTTOM_BUTTON_ACTION:
      return {
        ...state,
        showScrollToBottom: action.payload.showScrollToBottomButton,
      };
    case AI_CHATBOT_ACTIONS.SET_IS_STREAMING_RESPONSE:
      return {
        ...state,
        isStreamingResponse: action.payload.isStreamingResponse,
      };
    case AI_CHATBOT_ACTIONS.SET_IS_CREATING_NEW_SESSION:
      return {
        ...state,
        isCreatingNewSession: action.payload.isCreatingNewSession,
      };
    case AI_CHATBOT_ACTIONS.SET_CAN_CLONE_FROM_PREVIOUS_CHAT:
      return {
        ...state,
        canCloneFromPreviousChat: action.payload.canCloneFromPreviousChat,
      };
    case AI_CHATBOT_ACTIONS.SET_IS_CLONING_FROM_PREVIOUS_CHAT:
      return {
        ...state,
        isCloningFromPreviousChat: action.payload.isCloningFromPreviousChat,
      };
    case AI_CHATBOT_ACTIONS.SET_IS_AVAILABLE_IN_CURRENT_SUBSCRIPTION:
      return {
        ...state,
        isAvailableInCurrentSubscription: action.payload.isAvailableInCurrentSubscription,
      };

    case AI_CHATBOT_ACTIONS.SET_ERROR_WHILE_GENERATING_RESPONSE:
      return {
        ...state,
        errorWhileGeneratingResponse: action.payload.errorWhileGeneratingResponse,
      };

    case AI_CHATBOT_ACTIONS.SET_RATE_LIMIT_EXCEEDED:
      return {
        ...state,
        rateLimitExceeded: action.payload.rateLimitExceeded,
      };

    case AI_CHATBOT_ACTIONS.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
        errorWhileGeneratingResponse: !!action.payload.errorMessage,
      };

    case AI_CHATBOT_ACTIONS.SET_SHOW_RETRY_BUTTON:
      return {
        ...state,
        showRetryButton: action.payload.showRetryButton,
      };

    case AI_CHATBOT_ACTIONS.SET_RETRY_BUTTON_TEXT:
      return {
        ...state,
        retryButtonText: action.payload.retryButtonText,
      };

    default:
      return {};
  }
}
